import React from "react";
// import { StyledProgress } from './style';
import { StyledProgress } from "./Progress.styled";

const Progress = ({ percentage }) => {
  return <StyledProgress percentage={percentage}></StyledProgress>;
};

export default Progress;
